import { HoldingClass, Operation, Society } from 'types';

type GetOperationNominalValueProps = {
  holdingClass?: HoldingClass | null;
  operation: Operation;
  society: Society;
};

/**
 * Returns the nominal value from the first available source in this priority order:
 * 1. Holding class nominal value
 * 2. Operation nominal value
 * 3. Society nominal value
 * 4. Default to 0 if none of the above are available
 *
 * Uses nullish coalescing (`??`): only `null` and `undefined` are skipped.
 * A nominal value of `0` is kept (do not use `||` here or 0 would fall through).
 */
export const getOperationNominalValue = ({
  holdingClass,
  operation,
  society,
}: GetOperationNominalValueProps): number =>
  holdingClass?.nominalValue ??
  operation?.nominalValue ??
  society?.nominalValue ??
  0;
